import CardHeader from "components/CardHeader";
import { useOfficeTranslation } from "i18n/OfficeTranslation";
import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { Badge, Card, CardBody } from "reactstrap";
import { useDashboardData } from "./DashboardData";

const PendingDocumentsCard: React.FC = () => {
    const { t } = useOfficeTranslation();
    const { accounts, accountsFailed: failed, accountsLoading: loading } = useDashboardData();
    const pending = useMemo(() => accounts
        .filter(account => (account.pending_attachment_count ?? 0) > 0)
        .sort((left, right) => right.pending_attachment_count - left.pending_attachment_count
            || left.legal_name.localeCompare(right.legal_name)), [accounts]);
    const count = pending.reduce((total, account) => total + account.pending_attachment_count, 0);

    return <Card className="h-100 mb-0 dashboard-widget-card">
        <CardBody>
            <CardHeader
                title={t("dashboard.pendingDocumentsCard.title")}
                icon="mdi-file-check-outline"
                count={count}
                actions={<Link to="/accounts" className="btn btn-sm btn-light" aria-label={t("dashboard.pendingDocumentsCard.openAccounts")}>
                    <i className="mdi mdi-arrow-right" aria-hidden="true" />
                </Link>}
            />
            {loading && <p className="text-muted mt-3 mb-0">{t("dashboard.pendingDocumentsCard.loading")}</p>}
            {failed && <p className="text-danger mt-3 mb-0">{t("dashboard.pendingDocumentsCard.loadFailed")}</p>}
            {!loading && !failed && pending.length === 0 && <p className="text-muted mt-3 mb-0">{t("dashboard.pendingDocumentsCard.empty")}</p>}
            {!loading && !failed && <div className="dashboard-widget-scroll dashboard-operational-list">
                {pending.map(account => <Link
                    className="dashboard-operational-row text-body text-decoration-none"
                    key={account.id}
                    to={`/accounts/${account.id}`}
                >
                    <strong className="text-truncate min-w-0">{account.legal_name || account.id}</strong>
                    <Badge color="warning" className="bg-soft text-warning flex-shrink-0">
                        {t("dashboard.pendingDocumentsCard.documents", { count: account.pending_attachment_count })}
                    </Badge>
                </Link>)}
            </div>}
        </CardBody>
    </Card>;
};

export default PendingDocumentsCard;
